(function () {
  'use strict';
  function classify(data) {
    // An imported source category takes precedence over words in a system's specifications.
    if (data.catalogCategory && data.catalogCategory !== 'memory') return null;
    const title = String(data.title || '').toLowerCase();
    const body = String(data.description || '').toLowerCase();
    // Never treat memory specifications on another component as a RAM listing.
    if (/motherboard|logic board|system board|\bcpu\b|processor|\bssd\b|hard drive|flash|sdhc|sdxc|graphics|power supply/.test(title)) return null;
    if (data.catalogCategory !== 'memory' && !/\bram\b|memory|dimm|soimm|sdram|ddr\s*[345]|pc[345]/.test(title)) return null;
    const override = String(data.ramType || '').toLowerCase().replace(/ ram$/, '').trim();
    let type = ['laptop', 'desktop', 'server'].includes(override) ? override : '';
    function infer(text) {
      if (/\bserver\b|\brdimm\b|\blrdimm\b|\bregistered\b|\bpc[345]l?-\d+[re]\b/.test(text)) return 'server';
      if (/laptop|notebook|so[ -]?dimm|\bsoimm\b|\bpc[345]l?-\d+s\b/.test(text)) return 'laptop';
      if (/\becc\b/.test(text.replace(/non[ -]?ecc/g, ''))) return 'server';
      if (/desktop|\budimm\b|\bdimm\b|\bpc[345]l?-\d+u\b/.test(text)) return 'desktop';
      return '';
    }
    if (!type) type = infer(title) || infer(body);
    let generation = String(data.ramGeneration || '').trim().toUpperCase();
    if (!['DDR3','DDR4','DDR5'].includes(generation)) {
      const matches = [...title.matchAll(/\bddr\s*([345])l?\b|\bpc([345])l?[-\s]/g)];
      const generations = [...new Set(matches.map(match => 'DDR' + (match[1] || match[2])))];
      generation = generations.length === 1 ? generations[0] : '';
    }
    let brand = String(data.vendor || '').trim();
    if (/various|mixed|multiple/i.test(title + ' ' + brand) || /adata.*samsung|samsung.*kingston/i.test(brand)) brand = 'Mixed brands';
    else if (/^(sk\s*)?hynix$/i.test(brand)) brand = 'SK hynix';
    else if (/^mushkin(?: enhanced)?$/i.test(brand)) brand = 'Mushkin';
    else {
      const known = ['Samsung','Micron','Kingston','Crucial','Corsair','ADATA','Patriot','G.Skill'];
      brand = known.find(name => name.toLowerCase() === brand.toLowerCase()) || brand;
    }
    return type && generation && brand ? {type, generation, brand} : null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {classify};
  if (typeof document === 'undefined') return;
  if (window.tekMemoryLoaded) return;
  window.tekMemoryLoaded = true;
  function init(root) {
    if (root.dataset.memoryReady) return;
    const trigger = root.querySelector('[data-memory-trigger]');
    const panel = root.querySelector('[data-memory-picker]');
    if (!trigger || !panel) return;
    root.dataset.memoryReady = 'true';
    const type = panel.querySelector('[data-memory-type]');
    const generation = panel.querySelector('[data-memory-generation]');
    const brand = panel.querySelector('[data-memory-brand]');
    const status = panel.querySelector('[data-memory-status]');
    const results = panel.querySelector('[data-memory-results]');
    const retry = panel.querySelector('[data-memory-retry]');
    let entries = [], loading = false, controller;
    const typeNames = {laptop:'Laptop RAM', desktop:'Desktop RAM', server:'Server RAM'};
    function clearBrands() { brand.replaceChildren(new Option('Choose a brand', '')); brand.disabled = true; results.replaceChildren(); }
    function refresh() {
      results.replaceChildren();
      if (!type.value) { status.textContent = 'Choose Laptop, Desktop, or Server RAM to get started.'; return; }
      if (!generation.value) { status.textContent = 'Choose DDR3, DDR4, or DDR5 for ' + typeNames[type.value] + '.'; return; }
      const matches = entries.filter(entry => entry.type === type.value && entry.generation === generation.value);
      if (!matches.length) { status.textContent = 'No ' + generation.value + ' ' + typeNames[type.value].replace(' RAM', '').toLowerCase() + ' RAM' + ' is currently in stock. Try a different type or generation.'; return; }
      if (!brand.value) { status.textContent = matches.length + ' matching ' + (matches.length === 1 ? 'listing' : 'listings') + '. Choose an available brand.'; return; }
      const selected = matches.filter(entry => entry.brand === brand.value);
      for (const entry of selected) results.append(document.importNode(entry.template.content, true));
      status.textContent = selected.length + ' ' + brand.value + ' ' + generation.value + ' ' + typeNames[type.value].replace(' RAM', '').toLowerCase() + ' RAM' + ' ' + (selected.length === 1 ? 'listing' : 'listings') + ' in stock.';
    }
    type.addEventListener('change', () => { generation.value = ''; generation.disabled = !type.value; clearBrands(); refresh(); });
    generation.addEventListener('change', () => {
      clearBrands();
      const counts = new Map();
      entries.filter(entry => entry.type === type.value && entry.generation === generation.value).forEach(entry => counts.set(entry.brand,(counts.get(entry.brand)||0)+1));
      [...counts].sort(([a],[b])=>a.localeCompare(b)).forEach(([name,count])=>brand.add(new Option(name+' ('+count+')',name)));
      brand.disabled = !counts.size;
      if (!counts.size && generation.value) brand.options[0].textContent = 'No brands in stock';
      refresh();
    });
    brand.addEventListener('change', refresh);
    async function load() {
      if (loading) return;
      loading = true; entries = []; type.value = ''; generation.value = '';
      type.disabled = true; generation.disabled = true; clearBrands(); retry.hidden = true;
      panel.setAttribute('aria-busy','true'); status.textContent = 'Loading available RAM…';
      controller = new AbortController();
      try {
        let url = new URL(panel.dataset.feedUrl, location.origin);
        url.searchParams.set('section_id','tek-memory-feed');
        const seenPages = new Set(), seenProducts = new Set(), loaded = [];
        while (url) {
          if (url.origin !== location.origin || seenPages.has(url.href)) throw new Error('Invalid inventory page');
          seenPages.add(url.href);
          const response = await fetch(url,{signal:AbortSignal.any([controller.signal,AbortSignal.timeout(15000)]),cache:'no-store'});
          if (!response.ok) throw new Error('Inventory unavailable');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          if (!doc.querySelector('[data-memory-feed]')) throw new Error('Inventory unavailable');
          for (const template of doc.querySelectorAll('template[data-memory-item]')) {
            if (seenProducts.has(template.dataset.handle)) continue;
            seenProducts.add(template.dataset.handle);
            const info = classify(template.dataset);
            if (info) loaded.push({...info,template});
          }
          const next = doc.querySelector('[data-memory-next]');
          url = next ? new URL(next.getAttribute('href'),url) : null;
          if (url) url.searchParams.set('section_id','tek-memory-feed');
        }
        entries = loaded; type.disabled = false; refresh();
        if (!entries.length) status.textContent = 'No classified RAM is currently in stock. Try again later.';
      } catch (error) {
        if (controller.signal.aborted) return;
        status.textContent = 'We could not load current RAM inventory. Please try again.'; retry.hidden = false;
      } finally { loading = false; panel.removeAttribute('aria-busy'); }
    }
    trigger.setAttribute('aria-controls',panel.id); trigger.setAttribute('aria-expanded','false');
    function close() { panel.hidden = true; trigger.setAttribute('aria-expanded','false'); trigger.focus(); }
    root.addEventListener('tp:picker-open', event => { if(event.detail!==panel){panel.hidden=true;trigger.setAttribute('aria-expanded','false');} });
    trigger.addEventListener('click', event => {
      event.preventDefault();
      if (!panel.hidden) { close(); return; }
      root.dispatchEvent(new CustomEvent('tp:picker-open',{detail:panel}));
      panel.hidden = false; trigger.setAttribute('aria-expanded','true');
      panel.querySelector('[data-memory-heading]').focus({preventScroll:true});
      panel.scrollIntoView({block:'start',behavior:'instant'}); load();
    });
    panel.querySelector('[data-memory-close]').addEventListener('click',close);
    panel.addEventListener('keydown',event=>{if(event.key==='Escape')close();});
    retry.addEventListener('click',load);
  }
  function scan() { document.querySelectorAll('[data-category-gallery]').forEach(init); }
  scan(); document.addEventListener('shopify:section:load',scan);
})();
